<template>
    <form class="md:w-[360px]" @submit.prevent="submitForm">
        <FormInput label="E-MAIL" v-model="email" name="email" type="email" placeholder="e-mail" required />

        <button
            :disabled="showSuccessMessage"
            class="flex items-center w-full justify-center px-6 py-4 mt-4 group text-lg hover:opacity-80 text-black font-mono bg-brand-green  font-medium border border-brand-green uppercase hover:border-brand-green hover:text-brand-green hover:bg-brand-gray-700"
            type="submit">Zaslat přihlašovací odkaz</button>

        <div class="mt-3 text-white text-center">
          <span class="mr-2">Ještě nemáte účet?</span><a class="text-brand-green hover:opacity-80 hover:underline" :href="route('frontend.registration')">Vytvořte si ho</a>
        </div>

    </form>

    <div v-if="errorMessage !== null" class="p-4 mt-2  md:w-[320px] w-full rounded-md bg-brand-red">
      <div class="flex items-center">
        <div class="shrink-0">
          <ExclamationIcon class="w-5 h-5 text-white" aria-hidden="true" />
        </div>
        <div class="ml-3">
          <p class="text-sm font-semibold text-white text-body">
            {{ errorMessage }}
          </p>
        </div>
        <div class="pl-3 ml-auto">
          <div class="-mx-1.5 -my-1.5">
            <button
              @click="errorMessage = null"
              type="button"
              class="inline-flex bg-white rounded-md p-1.5 text-brand-red focus:outline-none"
            >
              <span class="sr-only">Dismiss</span>
              <XIcon class="w-5 h-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showSuccessMessage" class="p-4 mt-4 rounded-md md:w-[320px] w-full bg-brand-green">
      <div class="flex items-center">
        <div class="shrink-0">
          <CheckCircleIcon class="w-5 h-5 text-white" aria-hidden="true" />
        </div>
        <div class="ml-3">
          <p class="text-sm font-semibold text-white text-body">
            Na zadaný e-mail jsme vám zaslali přihlašovací odkaz, pokud jste se na něj registrovali.
          </p>
        </div>
        <div class="pl-3 ml-auto">
          <div class="-mx-1.5 -my-1.5">
            <button
              @click="showSuccessMessage = false"
              type="button"
              class="
                inline-flex
                bg-white
                rounded-md
                p-1.5
                text-brand-green
                focus:outline-none
              "
            >
              <span class="sr-only">Dismiss</span>
              <XIcon class="w-5 h-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import { ref } from 'vue';

import FormInput from "../Atomic/Input.vue";
import axios from "axios";
import { ExclamationIcon, XIcon, CheckCircleIcon } from "@heroicons/vue/solid";
import { useReCaptcha } from 'vue-recaptcha-v3';

export default {

    components: {
        FormInput,
        ExclamationIcon,
        XIcon,
        CheckCircleIcon
    },

    setup() {

      const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()

      const email = ref('');
      const errorMessage = ref(null);
      const showSuccessMessage = ref(false);

      const submitForm = async () => {
        errorMessage.value = null;

        await recaptchaLoaded();
        const token = await executeRecaptcha();

        try {
            await axios.post(route("user.send-login-link"), {
              email: email.value,
              recaptcha_token: token
            });
            showSuccessMessage.value = true;
        } catch (err) {
            if (err.response.status === 423) {
              errorMessage.value = "Zatím nelze odeslat přihlašovací e-mail znovu, počkejte prosím.";
            } else {
              errorMessage.value = "Nepodařilo se odeslat přihlašovací e-mail.";
            }
        }
      }

      return {
        email,
        errorMessage,
        showSuccessMessage,
        submitForm
      }
    }
}
</script>

<style>
</style>
